


















import Vue from 'vue';

import { Component, Prop } from 'vue-property-decorator';
import { CardPrice } from '@/types/network';

@Component({
  components: {
  },
})
export default class CardInfo extends Vue {
  @Prop() public cardPrice!: CardPrice;

  public priceClicked() {
    window.open(this.cardPrice.url);
  }
}
